import React from 'react';
import '../template-file-css/document-file-template.css';


export const LBS_MedManagementPsychiatricProgressNote = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='LBS_MedManagementPsychiatricProgressNote' className='file-pdf-document'>
            <div className='file-template'>
             <table>
                    <tr>
                        <td className='w-750'>
                           <span className='eleHeader'>General Appearance:</span>
                        </td>
                     </tr>
                     <tr>
                        <td className='w-187'>
                           <input type="checkbox" name="chkAppearance" id="chkAppearance" className='add-only' value="Healthy"/> Healthy;
                        </td>
                        <td className='w-187'>
                           <input type="checkbox" name="chkAppearance1" id="chkAppearance1" className='add-only' value="Age"/> As stated Age;
                        </td>
                        <td className='w-187'>
                           <input type="checkbox" name="chkAppearance2" id="chkAppearance2" className='add-only' value="Stated Age"/> Older Than Stated Age;  
                        </td>
                        <td className='w-187'>
                           <input type="checkbox" name="chkAppearance3" id="chkAppearance3" className='add-only' value="Young"/> Young-looking;
                        </td>
                     </tr>
                     <tr>
                        <td className='w-187'>
                           <input type="checkbox" name="chkAppearance4" id="chkAppearance4" className='add-only' value="Tattoos"/> Tattoos;
                        </td>
                        <td className='w-187'>
                           <input type="checkbox" name="chkAppearance5" id="chkAppearance5" className='add-only' value="Disheveled"/> Disheveled;
                        </td>
                        <td className='w-187'>
                           <input type="checkbox" name="chkAppearance6" id="chkAppearance6" className='add-only' value="Unkempt"/> Unkempt;
                        </td>
                        <td className='w-187'>
                           <input type="checkbox" name="chkAppearance7" id="chkAppearance7" className='add-only' value="Malodorous"/> Malodorous;
                        </td>
                     </tr>
                     <tr>
                        <td className='w-187'>
                           <input type="checkbox" name="chkAppearance8" id="chkAppearance8" className='add-only' value="Thin"/> Thin;
                        </td>
                        <td className='w-187'>
                           <input type="checkbox" name="chkAppearance9" id="chkAppearance9" className='add-only' value="Overweight"/> Overweight;
                        </td>
                        <td className='w-187'>
                           <input type="checkbox" name="chkAppearance10" id="chkAppearance10" className='add-only' value="Obese"/> Obese;
                        </td>
                     </tr>
                     <tr>
                        <td className='w-750'>
                           <input type="checkbox" name="chkAppearance111" id="chkAppearance111" className='add-only' value="Describe"/> Other/Describe:
                           <input type="text" id="txtAppearance" name="txtAppearance" className='add-only'/>
                        </td>
                     </tr>
                     <tr>
                        <td className='w-750'>
                           <span className='eleHeader'>Behavior& Psychomotor Activity:</span>
                        </td>
                     </tr>
                     <tr>
                        <td className='w-187'>
                           <input type="checkbox" name="chkBehavior1" id="chkBehavior1" className='add-only' value="Normal"/> Normal;
                        </td>
                        <td className='w-187'>
                           <input type="checkbox" name="chkBehavior2" id="chkBehavior2" className='add-only' value="Overactive"/> Overactive;
                        </td>
                        <td className='w-187'>
                           <input type="checkbox" name="chkBehavior3" id="chkBehavior3" className='add-only' value="Hypoactive"/> Hypoactive;  
                        </td>
                        <td className='w-187'>
                           <input type="checkbox" name="chkBehavior4" id="chkBehavior4" className='add-only' value="Catatonia"/> Catatonia;
                        </td>
                     </tr>
                     <tr>
                        <td className='w-187'>
                           <input type="checkbox" name="chkBehavior5" id="chkBehavior5" className='add-only' value="Tremor"/> Tremor;
                        </td>
                        <td className='w-187'>
                           <input type="checkbox" name="chkBehavior6" id="chkBehavior6" className='add-only' value="Tics"/> Tics;
                        </td>
                        <td className='w-187'>
                           <input type="checkbox" name="chkBehavior7" id="chkBehavior7" className='add-only' value="Combative"/> Combative;  
                        </td>
                     </tr>
                     <tr>
                        <td className='w-750'>
                           <input type="checkbox" name="chkBehavior8" id="chkBehavior8" className='add-only' value="Other Describe"/> Other/Describe
                           <input type="text" id="txtBehavior" name="txtBehavior" className='add-only'/>
                        </td>
                     </tr>
                  </table>
                  <h4>
                     Memory:
                  </h4>
                  <table>
                     <tr>
                        <td className='w-750'>
                           <span className='eleHeader'>Remote Memory:</span>
                        </td>
                     </tr>
                     <tr>
                        <td className='w-187'>
                           <input type="checkbox" name="chkRemoteMemory1" id="chkRemoteMemory1" className='add-only' value="Normal3"/> Normal;
                        </td>
                        <td className='w-187'>
                           <input type="checkbox" name="chkRemoteMemory2" id="chkRemoteMemory2" className='add-only' value="Impaired3"/> Impaired;
                        </td>
                     </tr>
                     <tr>
                        <td className='w-750'>
                           <span className='eleHeader'>Recent Memory:</span>
                        </td>
                     </tr>
                     <tr>
                        <td className='w-187'>
                           <input type="checkbox" name="chkRemoteMemory3" id="chkRemoteMemory3" className='add-only' value="Normal1"/> Normal;
                        </td>
                        <td className='w-187'>
                           <input type="checkbox" name="chkRemoteMemory4" id="chkRemoteMemory4" className='add-only' value="Impaired1"/> Impaired;
                        </td>
                     </tr>
                     <tr>
                        <td className='w-750'>
                           <span className='eleHeader'>Immediate Recall:</span>
                        </td>
                     </tr>
                     <tr>
                        <td className='w-187'>
                           <input type="checkbox" name="chkRemoteMemory5" id="chkRemoteMemory5" className='add-only' value="Normal2"/> Normal;
                        </td>
                        <td className='w-187'>
                           <input type="checkbox" name="chkRemoteMemory6" id="chkRemoteMemory6" className='add-only' value="Impaired2"/> Impaired;
                        </td>
                     </tr>
                     <tr>
                        <td className='w-750'>
                           <input type="checkbox" name="chkRemoteMemory7" id="chkRemoteMemory7" className='add-only' value="Other Describe"/> Other/Describe:
                           <input type="text" id="txtImmediateRecall" name="txtImmediateRecall" className='add-only'/>
                        </td>
                     </tr>
                  </table>
                  <table>
                     <tr>
                        <td className='w-750'>
                           <span className='eleHeader'>Attitude:</span>
                        </td>
                     </tr>
                     <tr>
                        <td className='w-187'>
                           <input type="checkbox" name="chkAttitude" id="chkAttitude" className='add-only' value="Cooperative"/> Cooperative
                        </td>
                        <td className='w-187'>
                           <input type="checkbox" name="chkAttitude1" id="chkAttitude1" className='add-only' value="Dependent"/> Dependent
                        </td>
                        <td className='w-187'>
                           <input type="checkbox" name="chkAttitude2" id="chkAttitude2" className='add-only' value="Dramatic"/> Dramatic 
                        </td>
                        <td className='w-187'>
                           <input type="checkbox" name="chkAttitude3" id="chkAttitude3" className='add-only' value="Passive"/> Passive
                        </td>
                     </tr>
                     <tr>
                        <td className='w-187'>
                           <input type="checkbox" name="chkAttitude4" id="chkAttitude4" className='add-only' value="Resistant"/> Resistant
                        </td>
                        <td className='w-187'>
                           <input type="checkbox" name="chkAttitude5" id="chkAttitude5" className='add-only' value="Critical"/> Critical
                        </td>
                        <td className='w-187'>
                           <input type="checkbox" name="chkAttitude6" id="chkAttitude6" className='add-only' value="Hostile"/> Hostile 
                        </td>
                        <td className='w-187'>
                           <input type="checkbox" name="chkAttitude7" id="chkAttitude7" className='add-only' value="Irritable"/> Irritable
                        </td>
                     </tr>
                     <tr>
                        <td className='w-187'>
                           <input type="checkbox" name="chkAttitude8" id="chkAttitude8" className='add-only' value="Sarcastic"/> Sarcastic
                        </td>
                        <td className='w-187'>
                           <input type="checkbox" name="chkAttitude9" id="chkAttitude9" className='add-only' value="Guarded"/> Guarded
                        </td>
                        <td className='w-187'>
                           <input type="checkbox" name="chkAttitude10" id="chkAttitude10" className='add-only' value="Defensive"/> Defensive 
                        </td>
                        <td className='w-187'>
                           <input type="checkbox" name="chkAttitude11" id="chkAttitude11" className='add-only' value="Manipulative"/> Manipulative
                        </td>
                     </tr>
                     <tr>
                        <td className='w-187'>
                           <input type="checkbox" name="chkAttitude12" id="chkAttitude12" className='add-only' value="Sarcastic"/> Argumentative
                        </td>
                     </tr>
                  </table>
                  <table>
                     <tr>
                        <td className='w-750'>
                           <span className='eleHeader'>Mood:</span>
                        </td>
                     </tr>
                     <tr>
                        <td className='w-187'>
                           <input type="checkbox" name="chkMood1" id="chkMood1" className='add-only' value="Normal"/> Normal
                        </td>
                        <td className='w-187'>
                           <input type="checkbox" name="chkMood2" id="chkMood2" className='add-only' value="Depressed"/> Depressed
                        </td>
                        <td className='w-187'>
                           <input type="checkbox" name="chkMood3" id="chkMood3" className='add-only' value="Anxious"/> Anxious 
                        </td>
                        <td className='w-187'>
                           <input type="checkbox" name="chkMood4" id="chkMood4" className='add-only' value="Hypomanic"/> Hypomanic
                        </td>
                     </tr>
                     <tr>
                        <td className='w-187'>
                           <input type="checkbox" name="chkMood5" id="chkMood5" className='add-only' value="Euphoric"/> Euphoric
                        </td>
                     </tr>
                     <tr>
                        <td className='w-750'>
                           <input type="checkbox" name="chkMood6" id="chkMood6" className='add-only' value="Other"/> Other
                           <input type="text" id="txtImmediateRecall7" name="txtImmediateRecall7" className='add-only'/>
                        </td>
                     </tr>
                     <tr>
                        <td className='w-750'>
                           <span className='eleHeader'>Appearance:</span>
                        </td>
                     </tr>
                     <tr>
                        <td className='w-187'>
                           <input type="checkbox" name="chkAppearance11" id="chkAppearance11" className='add-only' value="Overweight"/> Overweight
                        </td>
                        <td className='w-187'>
                           <input type="checkbox" name="chkAppearance21" id="chkAppearance21" className='add-only' value="Obese"/> Obese
                        </td>
                        <td className='w-187'>
                           <input type="checkbox" name="chkAppearance31" id="chkAppearance31" className='add-only' value="Underweight"/> Underweight 
                        </td>
                        <td className='w-187'>
                           <input type="checkbox" name="chkAppearance41" id="chkAppearance41" className='add-only' value="Neat"/> Neat
                        </td>
                     </tr>
                     <tr>
                        <td className='w-187'>
                           <input type="checkbox" name="chkAppearance51" id="chkAppearance51" className='add-only' value="Clean"/> Clean
                        </td>
                        <td className='w-187'>
                           <input type="checkbox" name="chkAppearance61" id="chkAppearance61" className='add-only' value="Careless"/> Careless
                        </td>
                        <td className='w-187'>
                           <input type="checkbox" name="chkAppearance71" id="chkAppearance71" className='add-only' value="Disheveled"/> Disheveled 
                        </td>
                        <td className='w-187'>
                           <input type="checkbox" name="chkAppearance81" id="chkAppearance81" className='add-only' value="Dirty"/> Dirty
                        </td>
                     </tr>
                     <tr>
                        <td className='w-187'>
                           <input type="checkbox" name="chkAppearance91" id="chkAppearance91" className='add-only' value="Appropriate"/> Appropriate
                        </td>
                     </tr>
                     <tr>
                        <td className='w-750'>
                           <span className='eleHeader'>Speech:</span>
                        </td>
                     </tr>
                     <tr>
                        <td className='w-187'>
                           <input type="checkbox" name="chkSpeech1" id="chkSpeech1" className='add-only' value="Relevant"/> Relevant
                        </td>
                        <td className='w-187'>
                           <input type="checkbox" name="chkSpeech2" id="chkSpeech2" className='add-only' value="Coherent"/> Coherent
                        </td>
                        <td className='w-187'>
                           <input type="checkbox" name="chkSpeech3" id="chkSpeech3" className='add-only' value="Clear"/> Clear 
                        </td>
                     </tr>
                     <tr>
                        <td className='w-750'>
                           <input type="checkbox" name="chkSpeech4" id="chkSpeech4" className='add-only' value="Other"/> Other:
                           <input type="text" id="txtSpeech4" name="txtSpeech4" className='add-only'/>
                        </td>
                     </tr>
                     <tr>
                        <td className='w-750'>
                           <span className='eleHeader'>Delusions:</span>
                        </td>
                     </tr>
                     <tr>
                        <td className='w-187'>
                           <input type="checkbox" name="chkDelusions1" id="chkDelusions1" className='add-only' value="None"/> None
                        </td>
                        <td className='w-187'>
                           <input type="checkbox" name="chkDelusions2" id="chkDelusions2" className='add-only' value="Paranoid"/> Paranoid
                        </td>
                        <td className='w-187'>
                           <input type="checkbox" name="chkDelusions3" id="chkDelusions3" className='add-only' value="Grandiose"/> Grandiose 
                        </td>
                        <td className='w-187'>
                           <input type="checkbox" name="chkDelusions4" id="chkDelusions4" className='add-only' value="Bizarre"/> Bizarre 
                        </td>
                     </tr>
                     <tr>
                        <td className='w-750'>
                           <span className='eleHeader'>Hallucinations:</span>
                        </td>
                     </tr>
                     <tr>
                        <td className='w-187'>
                           <input type="checkbox" name="chkHallucinations" id="chkHallucinations" className='add-only' value="None1"/> None
                        </td>
                        <td className='w-187'>
                           <input type="checkbox" name="chkHallucinations1" id="chkHallucinations1" className='add-only' value="Auditory"/> Auditory
                        </td>
                        <td className='w-187'>
                           <input type="checkbox" name="chkHallucinations2" id="chkHallucinations2" className='add-only' value="Visual"/> Visual 
                        </td>
                     </tr>
                     <tr>
                        <td className='w-750'>
                           <span className='eleHeader'>Behavior:</span>
                        </td>
                     </tr>
                     <tr>
                        <td className='w-187'>
                           <input type="checkbox" name="chkBehavior11" id="chkBehavior11" className='add-only' value="Underactive"/> Underactive
                        </td>
                        <td className='w-187'>
                           <input type="checkbox" name="chkBehavior21" id="chkBehavior21" className='add-only' value="Overactive"/> Overactive
                        </td>
                        <td className='w-187'>
                           <input type="checkbox" name="chkBehavior31" id="chkBehavior31" className='add-only' value="Disruptive"/> Disruptive 
                        </td>
                        <td className='w-187'>
                           <input type="checkbox" name="chkBehavior41" id="chkBehavior41" className='add-only' value="Control"/> Out of Control
                        </td>
                     </tr>
                     <tr>
                        <td className='w-187'>
                           <input type="checkbox" name="chkBehavior51" id="chkBehavior51" className='add-only' value="Calm"/> Calm
                        </td>
                        <td className='w-187'>
                           <input type="checkbox" name="chkBehavior61" id="chkBehavior61" className='add-only' value="Cooperative"/> Cooperative
                        </td>
                        <td className='w-187'>
                           <input type="checkbox" name="chkBehavior71" id="chkBehavior71" className='add-only' value="Focused"/> Focused 
                        </td>
                     </tr>
                     <tr>
                        <td className='w-750'>
                           <span className='eleHeader'>Thought Process:</span>
                        </td>
                     </tr>
                     <tr>
                        <td className='w-187'>
                           <input type="checkbox" name="chkProcess1" id="chkProcess1" className='add-only' value="Clear"/> Clear
                        </td>
                        <td className='w-187'>
                           <input type="checkbox" name="chkProcess2" id="chkProcess2" className='add-only' value="Lose"/> Lose Associations
                        </td>
                        <td className='w-187'>
                           <input type="checkbox" name="chkProcess3" id="chkProcess3" className='add-only' value="Flight"/> Flight of Ideas 
                        </td>
                        <td className='w-187'>
                           <input type="checkbox" name="chkProcess4" id="chkProcess4" className='add-only' value="Rambling"/> Rambling
                        </td>
                     </tr>
                     <tr>
                        <td className='w-187'>
                           <input type="checkbox" name="chkProcess5" id="chkProcess5" className='add-only' value="Disorganized"/> Disorganized
                        </td>
                     </tr>
                     <tr>
                        <td className='w-750'>
                           <span className='eleHeader'>Suicidal Thoughts:</span>
                        </td>
                     </tr>
                     <tr>
                        <td className='w-187'>
                           <input type="checkbox" name="chkSuicidal" id="chkSuicidal" className='add-only' value="None2"/> None
                        </td>
                        <td className='w-187'>
                           <input type="checkbox" name="chkSuicidal1" id="chkSuicidal1" className='add-only' value="Just"/> Just thoughts
                        </td>
                        <td className='w-187'>
                           <input type="checkbox" name="chkSuicidal2" id="chkSuicidal2" className='add-only' value="Plans"/> No Plans
                        </td>
                        <td className='w-187'>
                           <input type="checkbox" name="chkSuicidal3" id="chkSuicidal3" className='add-only' value="Attempt"/> No Attempt
                        </td>
                     </tr>
                     <tr>
                        <td className='w-187'>
                           <input type="checkbox" name="chkSuicidal4" id="chkSuicidal4" className='add-only' value="Intentions"/> No Intentions
                        </td>
                     </tr>
                     <tr>
                        <td className='w-750'>
                           <span className='eleHeader'>Homicidal Thoughts:</span>
                        </td>
                     </tr>
                     <tr>
                        <td className='w-187'>
                           <input type="checkbox" name="chkHomicidal1" id="chkHomicidal1" className='add-only' value="None2"/> None
                        </td>
                        <td className='w-187'>
                           <input type="checkbox" name="chkHomicidal2" id="chkHomicidal2" className='add-only' value="Just2"/> Just thoughts
                        </td>
                        <td className='w-187'>
                           <input type="checkbox" name="chkHomicidal3" id="chkHomicidal3" className='add-only' value="Plans2"/> No Plans
                        </td>
                        <td className='w-187'>
                           <input type="checkbox" name="chkHomicidal4" id="chkHomicidal4" className='add-only' value="Attempt2"/> No Attempt
                        </td>
                     </tr>
                     <tr>
                        <td className='w-187'>
                           <input type="checkbox" name="chkHomicidal5" id="chkHomicidal5" className='add-only' value="Intentions2"/> No Intentions
                        </td>
                     </tr>
                     <tr>
                        <td className='w-750'>
                           <span className='eleHeader'>Sensorium/Cognition</span>
                        </td>
                     </tr>
                     <tr>
                        <td className='w-187'>
                           <input type="checkbox" name="chkSensorium" id="chkSensorium" className='add-only' value="Alert"/> Alert
                        </td>
                        <td className='w-187'>
                           <input type="checkbox" name="chkSensorium1" id="chkSensorium1" className='add-only' value="Lethargic"/> Lethargic;
                        </td>
                        <td className='w-187'>
                           <input type="checkbox" name="chkSensorium2" id="chkSensorium2" className='add-only' value="Somnolent"/> Somnolent;
                        </td>
                        <td className='w-187'>
                           <input type="checkbox" name="chkSensorium3" id="chkSensorium3" className='add-only' value="Stuporous"/> Stuporous;
                        </td>
                     </tr>
                     <tr>
                        <td className='w-750'>
                           <span className='eleHeader'>Oriented to:</span>
                        </td>
                     </tr>
                     <tr>
                        <td className='w-187'>
                           <input type="checkbox" name="chkOriented" id="chkOriented" className='add-only' value="Person"/> Person;
                        </td>
                        <td className='w-187'>
                           <input type="checkbox" name="chkOriented1" id="chkOriented1" className='add-only' value="Place"/> Place;
                        </td>
                        <td className='w-187'>
                           <input type="checkbox" name="chkOriented2" id="chkOriented2" className='add-only' value="Time"/> Time;
                        </td>
                        <td className='w-187'>
                           <input type="checkbox" name="chkOriented3" id="chkOriented3" className='add-only' value="Situation"/> Situation;
                        </td>
                     </tr>
                     <tr>
                        <td className='w-187'>
                           <input type="checkbox" name="chkOriented4" id="chkOriented4" className='add-only' value="Concentration"/> Normal Concentration;
                        </td>
                        <td className='w-187'>
                           <input type="checkbox" name="chkOriented5" id="chkOriented5" className='add-only' value="Impaired"/> Impaired Concentration;
                        </td>
                     </tr>
                     <tr>
                        <td className='w-750'>
                           <input type="checkbox" name="chkOriented6" id="chkOriented6" className='add-only' value="Describe5"/> Other/Describe:
                           <input type="text" id="txtOriented" name="txtOriented" className='add-only'/>
                        </td>
                     </tr>
                     <tr>
                        <td className='w-750'>
                           <span className='eleHeader'>Intellectual Functioning (Estimate)</span>
                        </td>
                     </tr>
                     <tr>
                        <td className='w-187'>
                           <input type="checkbox" name="chkFunctioning" id="chkFunctioning" className='add-only' value="Avg"/> Above Avg.;
                        </td>
                        <td className='w-187'>
                           <input type="checkbox" name="chkFunctioning1" id="chkFunctioning1" className='add-only' value="Normal"/> Normal/Avg.;
                        </td>
                        <td className='w-187'>
                           <input type="checkbox" name="chkFunctioning2" id="chkFunctioning2" className='add-only' value="Borderline"/> Borderline;
                        </td>
                     </tr>
                     <tr>
                        <td className='w-750'>
                           <span className='eleHeader'>Mental Retardation:</span>
                        </td>
                     </tr>
                     <tr>
                        <td className='w-187'>
                           <input type="checkbox" name="chkRetardation1" id="chkRetardation1" className='add-only' value="Mild"/> Mild;
                        </td>
                        <td className='w-187'>
                           <input type="checkbox" name="chkRetardation2" id="chkRetardation2" className='add-only' value="Moderate"/> Moderate;
                        </td>
                        <td className='w-187'>
                           <input type="checkbox" name="chkRetardation3" id="chkRetardation3" className='add-only' value="Severe"/> Severe;
                        </td>
                     </tr>
                     <tr>
                        <td className='w-750'>
                           <input type="checkbox" name="chkRetardation" id="chkRetardation" className='add-only' value="Describe6"/> Other/Describe:
                           <input type="text" id="txtRetardation" name="txtRetardation" className='add-only'/>
                        </td>
                     </tr>
                     <tr>
                        <td className='w-750'>
                           <span className='eleHeader'>Judgement:</span>
                        </td>
                     </tr>
                     <tr>
                        <td className='w-250'>
                           <input type="checkbox" name="chkJudgement1" id="chkJudgement1" className='add-only' value="Critical"/> Critical Judgment Intact;
                        </td>
                        <td className='w-250'>
                           <input type="checkbox" name="chkJudgement2" id="chkJudgement2" className='add-only' value="Impaired"/> Impaired Judgment;
                        </td>
                     </tr>
                     <tr>
                        <td className='w-750'>
                           <input type="checkbox" name="chkJudgement3" id="chkJudgement3" className='add-only' value="Describe6"/> Other/Describe:
                           <input type="text" id="txtJudgement" name="txtJudgement" className='add-only'/>
                        </td>
                     </tr>
                     <tr>
                        <td className='w-750'>
                           <span className='eleHeader'>Insight:</span>
                        </td>
                     </tr>
                     <tr>
                        <td className='w-187'>
                           <input type="checkbox" name="chkInsight1" id="chkInsight1" className='add-only' value="Emotional"/> True Emotional Insight;
                        </td>
                        <td className='w-187'>
                           <input type="checkbox" name="chkInsight2" id="chkInsight2" className='add-only' value="Intellectual"/> Intellectual Insight;
                        </td>
                        <td className='w-300'>
                           <input type="checkbox" name="chkInsight3" id="chkInsight3" className='add-only' value="Illness"/> Some Awareness of Illness/symptoms;
                        </td>
                     </tr>
                     <tr>
                        <td className='w-187'>
                           <input type="checkbox" name="chkInsight4" id="chkInsight4" className='add-only' value="Insight6"/> Impaired Insight;
                        </td>
                        <td className='w-187'>
                           <input type="checkbox" name="chkInsight5" id="chkInsight5" className='add-only' value="Denial"/> Denial;
                        </td>
                     </tr>
                     <tr>
                        <td className='w-750'>
                           <input type="checkbox" name="chkInsight6" id="chkInsight6" className='add-only' value="Describe8"/> Other/Describe:
                           <input type="text" id="txtInsight" name="txtInsight" className='add-only'/>
                        </td>
                     </tr>
                  </table>
                  <table>
                     <tr>
                        <td className='w-750'>
                           <span className='eleHeader'>Impulse Control</span>
                        </td>
                     </tr>
                     <tr>
                        <td className='w-250'>
                           <input type="checkbox" name="chkImpulse1" id="chkImpulse1" className='add-only' value="Resist"/> Able to Resist Impulses;
                        </td>
                        <td className='w-250'>
                           <input type="checkbox" name="chkImpulse2" id="chkImpulse2" className='add-only' value="Recent"/> Recent Impulsive Behavior;
                        </td>
                        <td className='w-250'>
                           <input type="checkbox" name="chkImpulse3" id="chkImpulse3" className='add-only' value="IllnessControl"/> Impaired Impulse Control;
                        </td>
                     </tr>
                     <tr>
                        <td className='w-250'>
                           <input type="checkbox" name="chkImpulse4" id="chkImpulse4" className='add-only' value="Compulsions"/> Compulsions;
                        </td>
                     </tr>
                     <tr>
                         <td className='w-750'>
                           <input type="checkbox" name="chkImpulse5" id="chkImpulse5" className='add-only' value="Denial"/> Other/Describe:
                           <input type="text" id="txtImpulse" name="txtImpulse" className='add-only'/>
                        </td>
                     </tr>
                  </table>
                  <p className='w-750'>
                     <span className='eleHeader'>Diagnosis:</span>
                     <textarea id="txtDiagnosis" name="txtDiagnosis" className='add-only'></textarea>
                  </p>
                  <p className='w-750'>
                     <span className='eleHeader'>Diagnosis (es)Update/Change:</span>
                     <textarea id="txtDiagnosis1" name="txtDiagnosis1" className='add-only'></textarea>
                  </p>
                  <table>
                     <tr>
                        <td className='w-750'>
                           <span className='eleHeader'>Assessment: Medication Response</span>
                        </td>
                     </tr>
                     <tr>
                        <td className='w-150'>
                           <input type="checkbox" name="chkMedication" id="chkMedication" className='add-only' value="Full"/> Full
                        </td>
                        <td className='w-150'>
                           <input type="checkbox" name="chkMedication1" id="chkMedication1" className='add-only' value="Partial"/> Partial
                        </td>
                        <td className='w-150'>
                           <input type="checkbox" name="chkMedication2" id="chkMedication2" className='add-only' value="Minimal"/> Minimal
                        </td>
                        <td className='w-150'>
                           <input type="checkbox" name="chkMedication3" id="chkMedication3" className='add-only' value="None"/> None
                        </td>
                        <td className='w-150'>
                           <input type="checkbox" name="chkMedication4" id="chkMedication4" className='add-only' value="Worsening"/> Worsening
                        </td>
                     </tr>
                  </table>
                  <p className='w-750'>
                     <span className='eleHeader'>Plan: Medication Change if any:</span>
                     <textarea id="txtMedicationChange" name="txtMedicationChange" className='add-only'></textarea>
                  </p>
                  <table>
                     <tr>
                        <td className='w-750'>
                           <span className='eleHeader'>TREATMENT PLAN: </span><span className='small'>(Illness and symptoms management specific to-Add additional symptoms as indicated):</span>
                        </td>
                     </tr>
                     <tr>
                        <td className='w-750'>
                           <input type="checkbox" name="chkHyperactivity1" id="chkHyperactivity1" className='add-only' value="Hyperactivity"/> ADHD - Hyperactivity, impulse control, focus/concentration
                        </td>
                     </tr>
                     <tr>
                        <td className='w-750'>
                           <input type="checkbox" name="chkHyperactivity2" id="chkHyperactivity2" className='add-only' value="Aggression"/> ODD - Aggression, impulse control
                        </td>
                     </tr>
                     <tr>
                        <td className='w-750'>
                           <input type="checkbox" name="chkHyperactivity3" id="chkHyperactivity3" className='add-only' value="Intermittent"/> Intermittent Explosive Disorder/Disruptive Impulse Control -anger, aggression, impulse control, depression
                        </td>
                     </tr>
                     <tr>
                        <td className='w-750'>
                           <input type="checkbox" name="chkHyperactivity4" id="chkHyperactivity4" className='add-only' value="Conduct"/> Conduct Disorder -Aggression, anger, impulse control
                        </td>
                     </tr>
                     <tr>
                        <td className='w-750'>
                           <input type="checkbox" name="chkHyperactivity5" id="chkHyperactivity5" className='add-only' value="Depressive"/> Depressive Disorders - Mood regulation
                        </td>
                     </tr>
                     <tr>
                        <td className='w-750'>
                           <input type="checkbox" name="chkHyperactivity6" id="chkHyperactivity6" className='add-only' value="Mood"/> Mood Dysregulation Disorder - Mood regulation
                        </td>
                     </tr>
                     <tr>
                        <td className='w-750'>
                           <input type="checkbox" name="chkHyperactivity7" id="chkHyperactivity7" className='add-only' value="Anxiety"/> Anxiety & Phobia related disorders - Irritability, concentration, restlessness, anxiousness
                        </td>
                     </tr>
                     <tr>
                        <td className='w-750'>
                           <input type="checkbox" name="chkHyperactivity8" id="chkHyperactivity8" className='add-only' value="Agitation"/> PTSD & other trauma related disorders - Agitation, irritability, hypervigilance, anxiety
                        </td>
                     </tr>
                     <tr>
                        <td className='w-750'>
                           <input type="checkbox" name="chkHyperactivity9" id="chkHyperactivity9" className='add-only' value="Bipolar"/> Bipolar - Mania & Mood stabilization
                        </td>
                     </tr>
                     <tr>
                        <td className='w-750'>
                           <input type="checkbox" name="chkHyperactivity10" id="chkHyperactivity10" className='add-only' value="Schizophrenia"/> Schizophrenia Spectrum & Other psychotic disorders - Psychosis stabilization
                        </td>
                     </tr>
                     <tr>
                        <td className='w-750'>
                           <input type="checkbox" name="chkHyperactivity11" id="chkHyperactivity11" className='add-only' value="Hypervigilance"/> OCD - Agitation, hypervigilance, fear, compulsions, rumination, and anxiousness
                        </td>
                     </tr>
                     <tr>
                        <td className='w-750'>
                           <input type="checkbox" name="chkHyperactivity12" id="chkHyperactivity12" className='add-only' value="Disorders"/> Substance Related Disorders: (Referral information):
                        </td>
                     </tr>
                     <tr>
                        <td className='w-750'>
                           <input type="text" id="txtHyperactivity13" name="txtHyperactivity13" className='add-only'/>
                        </td>
                     </tr>
                     <tr>
                        <td className='w-750'>
                           <input type="checkbox" name="chkHyperactivity14" id="chkHyperactivity14" className='add-only' value="Please"/> Other Please Explain:
                        </td>
                     </tr>
                     <tr>
                        <td className='w-750'>
                           <input type="text" id="txtHyperactivity15" name="txtHyperactivity15" className='add-only'/>
                        </td>
                     </tr>
                  </table>
                  <table>
                     <tr>
                        <td className='w-750'>
                           <span className='eleHeader'>Recommended Services:</span>
                        </td>
                     </tr>
                     <tr>
                        <td className='w-350'>
                           <input type="checkbox" name="chkServices1" id="chkServices1" className='add-only' value="Skills"/> Skills Training and Development
                        </td>
                        <td className='w-250'>
                           <input type="checkbox" name="chkServices2" id="chkServices2" className='add-only' value="Targeted"/> Targeted Case Management
                        </td>
                        <td className='w-150'>
                           <input type="checkbox" name="chkServices3" id="chkServices3" className='add-only' value="Psychotherapy"/> Psychotherapy
                        </td>
                     </tr>
                     <tr>
                        <td className='w-350'>
                           <input type="checkbox" name="chkServices4" id="chkServices4" className='add-only' value="Medication"/> Medication Training and Support
                           Management
                        </td>
                     </tr>
                     <tr>
                        <td className='w-750'>
                           <input type="checkbox" name="chkServices5" id="chkServices5" className='add-only' value="Denial"/> Other
                           <input type="text" id="txtServices6" name="txtServices6" className='add-only'/>
                        </td>
                     </tr>
                  </table>
                  <table>
                     <tr>
                        <td className='w-750'>
                           <span className='eleHeader'>Follow - up  </span><span className='small'>(Frequency):</span>
                        </td>
                     </tr>
                     <tr>
                        <td className='w-250'>
                           <input type="radio" id="rbFollow_Yes" name="rbFollow" className='add-only' value="1" /> 1 Month
                        </td>
                        <td className='w-250'>
                           <input type="radio" id="rbFollow_Ys" name="rbFollow" className='add-only' value="2" /> 2 Months
                        </td>
                        <td className='w-250'>
                           <input type="radio" id="rbFollow_Ye" name="rbFollow" className='add-only' value="3" /> 3 Months
                        </td>
                     </tr>
                  </table>
                  <table>
                     <tr>
                        <td className='w-375'>
                           <span className='eleHeader'>Amount:</span>
                        </td>
                        <td className='w-375'>
                           <span className='eleHeader'>Duration:</span>
                        </td>
                     </tr>
                     <tr>
                        <td className='w-375'>
                           <input type="text" id="txtAmount" name="txtAmount" className='add-only'/>
                        </td>
                        <td className='w-375'>
                           <input type="text" id="txtDuration" name="txtDuration" className='add-only'/>
                        </td>
                     </tr>
                  </table>
                  <table>
                     <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                     <tr>
                        <td className='small w-375'>Psychiatrist Signature</td>
                        <td className='small w-375'>Date</td>
                    </tr>
                  </table>
                  <table>
                     <tr>
                        <td className='w-250'>
                           <span className='eleHeader'>Client Name:</span>
                           <input type="text" name="txtClientName" id="txtClientName" className='add-only'/>
                        </td>
                        <td className='w-250'>
                           <span className='eleHeader'>Date of Birth:</span>                        
                           <input type="text" name="txtDob" id="txtDob" className='add-only'/>
                        </td>
                        <td className='w-250'>
                           <span className='eleHeader'>Service Date:</span>                        
                           <input type="text" name="txtServiceDate" id="txtServiceDate" className='add-only' />
                        </td>
                     </tr>
                     <tr>
                        <td className='w-250'>
                           <span className='eleHeader'>Session Start Time:</span>
                           <input type="text" name="txtSessionStart" id="txtSessionStart" className='add-only'/>
                        </td>
                        <td className='w-250'>
                           <span className='eleHeader'>Session End Time:</span>                        
                           <input type="text" name="txtSessionEnd" id="txtSessionEnd" className='add-only'/>
                        </td>
                     </tr>
                  </table>
                  <table>
                     <tr>
                        <td className='w-750'>
                           <span className='eleHeader'>Service Type:</span>
                        </td>
                     </tr>
                     <tr>
                        <td className='w-250'>
                           <input type="radio" id="rbQuestions_Yes" name="rbQuestions" className='add-only' value="1" /> Follow-up                        
                        </td>
                        <td className='w-250'>
                           <input type="radio" id="rbQuestions_No" name="rbQuestions" className='add-only' value="0" /> Medication Management
                        </td>
                     </tr>
                  </table>
                  <table>
                     <tr>
                        <td className='w-750'>
                           <span className='eleHeader'>Seen in:</span>
                        </td>
                     </tr>
                     <tr>
                        <td className='w-250'>
                           <input type="radio" id="rbQuestions1_Yes" name="rbQuestions1" className='add-only' value="1" /> Person                       
                        </td>
                        <td className='w-250'>
                           <input type="radio" id="rbQuestions1_No" name="rbQuestions1" className='add-only' value="0" /> Video
                        </td>
                     </tr>
                  </table>
                  <table>
                     <tr>
                        <td className='w-750'>
                           <span className='eleHeader'>Patient Location:</span>
                        </td>
                     </tr>
                     <tr>
                        <td className='w-200'>
                           <input type="radio" id="rbQuestions2_Yes" name="rbQuestions2" className='add-only' value="1" /> Office                       
                        </td>
                        <td className='w-200'>
                           <input type="radio" id="rbQuestions2_No" name="rbQuestions2" className='add-only' value="0" /> Home
                        </td>
                        <td className='w-350'>
                           <input type="radio" id="rbQuestions2_Nl" name="rbQuestions2" className='add-only' value="2" /> Other:
                           <input type="text" name="txtPatient" id="txtPatient" className='add-only'/>
                        </td>
                     </tr>
                  </table>
                  <table>
                     <tr>
                        <td className='w-750'>
                           <span className='eleHeader'>Others in Attendance:</span>
                        </td>
                     </tr>
                     <tr>
                        <td className='w-200'>
                           <input type="radio" id="rbQuestions3_Yes" name="rbQuestions3" className='add-only' value="1" /> Parent/Guardian                       
                        </td>
                        <td className='w-200'>
                           <input type="radio" id="rbQuestions3_No" name="rbQuestions3" className='add-only' value="0" /> Sister/Brother:
                        </td>
                        <td className='w-350'>
                           <input type="radio" id="rbQuestions3_Nl" name="rbQuestions3" className='add-only' value="2" /> Other:
                           <input type="text" name="txtPatient1" id="txtPatient1" className='add-only'/>
                        </td>
                     </tr>
                  </table>
                  <h4>
                     Vitals:
                  </h4>
                  <table>
                     <tr>                        
                        <td className='w-250'>
                           <span className='eleHeader'>Blood Pressure:</span>                        
                           <input type="text" name="txtBlood" id="txtBlood" className='add-only' />
                        </td>
                        <td className='w-250'>
                           <span className='eleHeader'>Pulse:</span>                        
                           <input type="text" name="txtPulse" id="txtPulse" className='add-only' />
                        </td>
                        <td className='w-250'>
                           <span className='eleHeader'>Weight:</span>
                           <input type="text" name="txtWeight" id="txtWeight" className='add-only' />
                        </td>
                     </tr>
                     <tr>
                        <td className='w-250'>
                           <span className='eleHeader'>Pain:</span>                        
                           <input type="text" name="txtWeightPain" id="txtWeightPain" className='add-only' />
                        </td>
                     </tr>
                  </table>
                  <h4>
                     Current Medication:
                  </h4>
                  <table>
                     <tr>
                        <td className='w-375'>
                           <span className='eleHeader'>Same as prescribed during last visit</span>
                        </td>
                        <td className='w-375'>
                           <span className='eleHeader'>Compliant with Medications:</span>
                        </td>
                     </tr>
                     <tr>
                        <td className='w-375'>
                           <input type="radio" id="rbMedication_Yes" name="rbMedication" className='add-only' value="1" /> Yes&nbsp;&nbsp;&nbsp;
                           <input type="radio" id="rbMedication_No" name="rbMedication" className='add-only' value="0" /> No
                        </td>
                        <td className='w-375'>
                           <input type="radio" id="rbMedication1_Yes" name="rbMedication1" className='add-only' value="1" /> Yes&nbsp;&nbsp;&nbsp;
                           <input type="radio" id="rbMedication1_No" name="rbMedication1" className='add-only' value="0" /> No
                        </td>
                     </tr>
                  </table>
                  <p className='w-750'>
                     <span className='eleHeader'>Verbal Medication Consent:</span>
                     <input type="radio" id="rbMedication2_Yes" name="rbMedication2" className='add-only' value="1" /> Yes&nbsp;&nbsp;&nbsp;
                     <input type="radio" id="rbMedication2_No" name="rbMedication2" className='add-only' value="0" /> No
                  </p>
                  <table>
                     <tr>
                        <td className='w-375'>
                           <span className='eleHeader'>ETOHuse:</span>
                        </td>
                        <td className='w-375'>
                           <span className='eleHeader'>DRUGUSE</span>
                        </td>
                     </tr>
                     <tr>
                        <td className='w-375'>
                           <input type="radio" id="rbMedication3_Yes" name="rbMedication3" className='add-only' value="1" /> Yes&nbsp;&nbsp;&nbsp;
                           <input type="radio" id="rbMedication3_No" name="rbMedication3" className='add-only' value="0" /> No
                        </td>
                        <td className='w-375'>
                           <input type="radio" id="rbMedication4_Yes" name="rbMedication4" className='add-only' value="1" /> Yes&nbsp;&nbsp;&nbsp;
                           <input type="radio" id="rbMedication4_No" name="rbMedication4" className='add-only' value="0" /> No
                        </td>
                     </tr>
                  </table>
                  <table>
                     <tr>
                        <td className='w-200'>
                           <span className='eleHeader'>Name of Medications</span>
                        </td>
                        <td className='w-150'>
                           <span className='eleHeader'>Dose/Strength</span> 
                        </td>
                        <td className='w-400'>
                           <span className='eleHeader'>What is this medication used to treat?</span>  
                        </td>
                     </tr>
                     <tr>
                        <td className='w-200'>
                           <input type="text" name="txtMedications" id="txtMedications" className='add-only'/>
                        </td>
                        <td className='w-150'>                       
                           <input type="text" name="txtStrength" id="txtStrength" className='add-only'/>
                        </td>
                        <td className='w-400'>                    
                           <input type="text" name="txtPulseDose" id="txtPulseDose" className='add-only'/>
                        </td>
                     </tr>
                     <tr>
                        <td className='w-200'>
                           <input type="text" name="txtMedications1" id="txtMedications1" className='add-only'/>
                        </td>
                        <td className='w-150'>                       
                           <input type="text" name="txtStrength1" id="txtStrength1" className='add-only'/>
                        </td>
                        <td className='w-400'>                    
                           <input type="text" name="txtPulseDose1" id="txtPulseDose1" className='add-only'/>
                        </td>
                     </tr>
                     <tr>
                        <td className='w-200'>
                           <input type="text" name="txtMedications2" id="txtMedications2" className='add-only'/>
                        </td>
                        <td className='w-150'>                       
                           <input type="text" name="txtStrength2" id="txtStrength2" className='add-only' />
                        </td>
                        <td className='w-400'>                    
                           <input type="text" name="txtPulseDose2" id="txtPulseDose2" className='add-only' />
                        </td>
                     </tr>
                     <tr>
                        <td className='w-200'>
                           <input type="text" name="txtMedications3" id="txtMedications3" className='add-only'/>
                        </td>
                        <td className='w-150'>                       
                           <input type="text" name="txtStrength3" id="txtStrength3" className='add-only' />
                        </td>
                        <td className='w-400'>                    
                           <input type="text" name="txtPulseDose3" id="txtPulseDose3" className='add-only' />
                        </td>
                     </tr>
                  </table>
                  <table>
                     <tr>
                        <td className='w-750'>
                           <span className='eleHeader'>Side Effect:</span>
                        </td>
                     </tr>
                     <tr>
                        <td className='w-225'>
                           <input type="radio" id="rbEffect51_Yes" name="rbEffect51" className='add-only' value="1" /> Types of side effect                      
                        </td>
                        <td className='w-300'>
                           <input type="radio" id="rbEffect51_No" name="rbEffect51" className='add-only' value="0" /> Timing &frequency of side effect
                        </td>
                        <td className='w-225'>
                           <input type="radio" id="rbEffect51_Nl" name="rbEffect51" className='add-only' value="2" /> Potential preventive measure
                        </td>
                     </tr>
                  </table>
                  <table>
                     <tr>
                        <td className='w-750'>
                           <span className='eleHeader'>Verbalizes purpose/action of meds:</span>
                        </td>
                     </tr>
                     <tr>
                        <td className='w-225'>
                           <input type="radio" id="rbEffect_Yes" name="rbEffect" className='add-only' value="1" /> Correctly                   
                        </td>
                        <td className='w-300'>
                           <input type="radio" id="rbEffect_No" name="rbEffect" className='add-only' value="0" /> Incorrectly
                        </td>
                        <td className='w-225'>
                           <input type="radio" id="rbEffect_Nl" name="rbEffect" className='add-only' value="2" /> Unable
                        </td>
                     </tr>
                  </table>
                  <table>
                     <tr>
                        <td className='w-750'>
                           <span className='eleHeader'>Drug Interactions:</span>
                        </td>
                     </tr>
                     <tr>
                        <td className='w-375'>
                           <input type="checkbox" name="chkDrugInteractions1" id="chkDrugInteractions1" className='add-only' value="Drugs"/> Drugs/illicit drugs interaction
                        </td>
                        <td className='w-375'>
                           <input type="checkbox" name="chkDrugInteractions2" id="chkDrugInteractions2" className='add-only' value="Interactions"/> Drug food interactions
                        </td>
                     </tr>
                     <tr>
                        <td className='w-375'>
                           <input type="checkbox" name="chkDrugInteractions3" id="chkDrugInteractions3" className='add-only' value="Herbs"/> Interactions with herbs & Over-the-counter meds
                        </td>
                        <td className='w-375'>
                           <input type="checkbox" name="chkDrugInteractions4" id="chkDrugInteractions4" className='add-only' value="Alcohol"/> Interactions with alcohol & tobacco
                        </td>
                     </tr>
                     <tr>
                        <td className='w-375'>
                           <input type="checkbox" name="chkDrugInteractions5" id="chkDrugInteractions5" className='add-only' value="Herbs"/> Dietary Restrictions
                        </td>
                        <td className='w-375'>
                           <input type="checkbox" name="chkDrugInteractions6" id="chkDrugInteractions6" className='add-only' value="Alcohol"/> Pregnancy/Child Bearing, when
                           applicable
                        </td>
                     </tr>
                  </table>
                  <table>
                     <tr>
                        <td className='w-750'>
                           <span className='eleHeader'>Verbalizes purpose/action of meds:</span>
                        </td>
                     </tr>
                     <tr>
                        <td className='w-225'>
                           <input type="radio" id="rbEffect1_Yes" name="rbEffect1" className='add-only' value="1" /> Correctly                   
                        </td>
                        <td className='w-300'>
                           <input type="radio" id="rbEffect1_No" name="rbEffect1" className='add-only' value="0" /> Incorrectly
                        </td>
                        <td className='w-225'>
                           <input type="radio" id="rbEffect1_Nl" name="rbEffect1" className='add-only' value="2" /> Unable
                        </td>
                     </tr>
                  </table>
                  <p className='w-750'>
                     <span className='eleHeader'>Adherence:</span>
                     <input type="radio" id="rbAdherence_Yes" name="rbAdherence" className='add-only' value="1" /> Yes
                     <input type="radio" id="rbAdherence_No" name="rbAdherence" className='add-only' value="0" /> No
                  </p>
                  <table>
                     <tr>
                        <td className='w-750'>
                           <span className='eleHeader'>Verbalizes purpose/action of meds:</span>
                        </td>
                     </tr>
                     <tr>
                        <td className='w-225'>
                           <input type="radio" id="rbEffect2_Yes" name="rbEffect2" className='add-only' value="1" /> Correctly                   
                        </td>
                        <td className='w-300'>
                           <input type="radio" id="rbEffect2_No" name="rbEffect2" className='add-only' value="0" /> Incorrectly
                        </td>
                        <td className='w-225'>
                           <input type="radio" id="rbEffect2_Nl" name="rbEffect2" className='add-only' value="2" /> Unable
                        </td>
                     </tr>
                  </table>
                  <table>
                     <tr>
                        <td className='w-750'>
                           <span className='eleHeader'>Appetite:</span>
                        </td>
                     </tr>
                     <tr>
                        <td className='w-225'>
                           <input type="radio" id="rbEffect4_Yes" name="rbEffect4" className='add-only' value="1" /> Normal                   
                        </td>
                        <td className='w-300'>
                           <input type="radio" id="rbEffect4_No" name="rbEffect4" className='add-only' value="0" /> Increased
                        </td>
                        <td className='w-225'>
                           <input type="radio" id="rbEffect4_Nl" name="rbEffect4" className='add-only' value="2" /> Decreased
                        </td>
                     </tr>
                  </table>
                  <table>
                     <tr>
                        <td className='w-750'>
                           <span className='eleHeader'>Sleeping Pattern:</span>
                        </td>
                     </tr>
                     <tr>
                        <td className='w-225'>
                           <input type="radio" id="rbEffect5_Yes" name="rbEffect5" className='add-only' value="1" /> Normal                   
                        </td>
                        <td className='w-300'>
                           <input type="radio" id="rbEffect5_No" name="rbEffect5" className='add-only' value="0" /> Sporadic
                        </td>
                        <td className='w-225'>
                           <input type="radio" id="rbEffect5_Nl" name="rbEffect5" className='add-only' value="2" /> Poor
                        </td>
                     </tr>
                  </table>
                  <table>
                     <tr>
                        <td className='w-750'>
                           <span className='eleHeader'>Motivation:</span>
                        </td>
                     </tr>
                     <tr>
                        <td className='w-200'>
                           <input type="radio" id="rbEffect6_Yes" name="rbEffect6" className='add-only' value="1" /> None                   
                        </td>
                        <td className='w-200'>
                           <input type="radio" id="rbEffect6_No" name="rbEffect6" className='add-only' value="0" /> Low
                        </td>
                        <td className='w-200'>
                           <input type="radio" id="rbEffect6_Nl" name="rbEffect6" className='add-only' value="2" /> Moderate
                        </td>
                        <td className='w-150'>
                           <input type="radio" id="rbEffect6_Np" name="rbEffect6" className='add-only' value="3" /> High
                        </td>
                     </tr>
                  </table>
                  <p className='w-750'>
                     <span className='eleHeader'>Presenting Problem/progress since last visit:</span>
                     <textarea id="txtPresentingProblem" name="txtPresentingProblem" className='add-only'></textarea>
                  </p>
            </div>
        </form>
    )
}
